import { AxiosRequestConfig, AxiosResponse } from 'axios';

import {
  ICreateDepartmentRequest,
  IDepartmentResponse,
  IUpdateDepartmentRequest,
} from './deparment.interface';

import { axiosApiInstance } from 'services/config';

class DepartmentApi {
  async getAllDepartments(config?: AxiosRequestConfig): Promise<IDepartmentResponse[]> {
    const response: AxiosResponse<IDepartmentResponse[]> = await axiosApiInstance.get(
      'department',
      config,
    );
    return response.data;
  }

  async createDepartment(
    departmentData: ICreateDepartmentRequest,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const { name, organizationId, assignedMentorId } = departmentData;
    await axiosApiInstance.post(
      'department',
      {
        name,
        organizationId,
        assignedMentorId: assignedMentorId ?? null,
      },
      config,
    );
  }

  async updateDepartment(
    departmentData: IUpdateDepartmentRequest,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const { id, name, assignedMentorId } = departmentData;
    await axiosApiInstance.put(
      `department/${id}`,
      {
        name,
        assignedMentorId: assignedMentorId ?? null,
      },
      config,
    );
  }

  async removeDepartment(
    departmentId: number,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    await axiosApiInstance.delete(`department/${departmentId}`, config);
  }
}

export { DepartmentApi };
